var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 429 484.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6e6ed;}.cls-2{fill:#e1f4fd;}.cls-3{fill:#d63c53;}.cls-4{fill:#ef4154;}.cls-5{fill:none;stroke:#d63c53;stroke-miterlimit:10;stroke-width:35px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.59,
    y: 153.88,
    width: 395.83,
    height: 330.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 138.4,
    width: 429,
    height: 76.29
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "275.31 214.69 275.31 484.47 194.6 484.47 194.6 214.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "194.6 214.69 194.6 138.4 275.31 138.4 275.31 214.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.59,
    y: 309.77,
    width: 395.83,
    height: 75.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.08,83.91c30.18,0,91.38,34.67,119.49,63.25,0,0-30.15,12.42-62.48,12.42-27.37,0-56.3-8.89-69.87-41.75-10.14-24.53-2.84-33.92,12.86-33.92m0-35h0c-25.93,0-38.89,13.59-44.31,21.69-10.64,15.91-10.94,36.3-.9,60.6,9.37,22.68,25.33,40.3,46.15,51,16.06,8.23,34.92,12.4,56.07,12.4,38.16,0,72.08-13.52,75.82-15.07L311,159.69l-36.49-37.08c-16.24-16.5-40.75-34.2-67.24-48.56-21.16-11.47-51.73-25.14-77.2-25.14Z",
    transform: "translate(-61 -15.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M460.12,218.25C398.2,231.51,291,164.31,291,164.31s-45.27,110.33-105,112",
    transform: "translate(-61 -15.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413.11,50.49c7.42,0,12.11,6.26,11.93,21.7-.73,60.73-93.57,65.82-93.57,65.82,14.67-33.75,59.89-87.52,81.64-87.52m0-35c-13,0-26.32,5.16-40.68,15.79-9.2,6.8-18.9,15.86-28.84,26.93-18.93,21.09-35.46,45.7-44.22,65.84l-22.61,52,56.62-3.1a207.68,207.68,0,0,0,57-12.37c18.31-7,33.36-16.4,44.73-28A85.79,85.79,0,0,0,460,72.61c.23-18.88-4.79-33.66-14.92-43.91a44.59,44.59,0,0,0-32-13.21Z",
    transform: "translate(-61 -15.49)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.c4e49ce9.svg";
export { ForwardRef as ReactComponent };